package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.input.InputSecureText
import com.wintermar.inspection.core.ui.component.input.InputText
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputType
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun InputWithLabel(
    inputState: InputState,
    modifier: Modifier = Modifier,
) {
    val space = LocalAppTheme.current.dimension.spacing

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(space.space2)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(space.space1)
        ) {
            TextBodySmall(text = inputState.label, bold = true)
            if (inputState.mandatory && inputState.showAsterisk) {
                TextBodySmall(text = "*", bold = true, color = { it.error.default })
            }
        }

        if (inputState.type == InputType.PASSWORD) {
            InputSecureText(
                state = inputState,
                modifier = Modifier.fillMaxWidth()
            )
        } else { // default input is InputText
            InputText(
                state = inputState,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}
